import {AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {ROOT_SECURED} from '../../../../core/services/routes.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements AfterViewInit {
    @ViewChild('focus', {static: false}) elementFocus: ElementRef | undefined;
    @Input() isAudioMode: boolean | undefined;
    @Output() stopAudioEvent = new EventEmitter();

    constructor(private http: HttpClient, private router: Router) {
    }

    onLoginClick(): void {
        this.stopAudioEvent.emit();
        this.router.navigate([ROOT_SECURED]);
    }

    ngAfterViewInit(): void {
        if (this.isAudioMode) {
            this.elementFocus?.nativeElement.querySelector('button').focus();
        }
    }
}
